namespace SolovisGateway.Admin.Organizations {

    export interface OrgUserListControlOptions extends Solovis.UI.BaseControlOptions {
        organizationId: number;
        restrictedAdminUIEnabled: boolean;
    }

    export class OrgUserListControl extends Solovis.UI.BaseControl {

        private _organizationId: number;

        private _userList: Array<OrganizationUser>;
        private _restrictedAdminUIEnabled: boolean;
        private _toolbarContainer;
        private _toolbar: Solovis.UI.Toolbar;

        private _dataGrid: DevExpress.ui.dxDataGrid;

        constructor(options: OrgUserListControlOptions) {
            super(options);
            this._restrictedAdminUIEnabled = options.restrictedAdminUIEnabled ? true : false;
            this._organizationId = options.organizationId;
        }

        public async doInitAsync(): Promise<void> {
            let response = await Solovis.Rpc.invoke("~/Organization/GetOrganizationUsers", { organizationId: this._organizationId });

            this._userList = response.result.users.map(user => new OrganizationUser(user));
        }

        public doRender() {
            let self = this;

            this._toolbarContainer = $("<div>").appendTo(this.container);

            var toolbar = new Solovis.UI.Toolbar({
                container: this._toolbarContainer
            });
            this._toolbar = toolbar;


            if (!this._restrictedAdminUIEnabled) {
                toolbar.addItem({
                    name: "addOrgUserButton",
                    createToolbarItem: function () {
                        var addUserButton = new Solovis.UI.Buttons.Button({
                            element: $("<div>").text("Add Organization User").prepend($("<span>").css("padding-right", "5px").addClass("fa fa-user-plus")),
                            size: "small",
                            click: function () {
                                self._showAddOrgUserInterface();
                            }
                        });

                        return addUserButton;
                    }
                });

                toolbar.addItem({
                    name: "addUsersToOrgButton",
                    createToolbarItem: function () {
                        return new Solovis.UI.Buttons.Button({
                            element: $("<div>")
                                .text("Add Users to Organization")
                                .prepend($("<span>")
                                    .css("padding-right", "5px")
                                    .addClass("fa fa-upload")),
                            size: "small",
                            click: function () {
                                location.href = Solovis.resolveUrl("~/Admin/UserAdmin/AddUsersToOrganizations")
                            }
                        });
                    }
                });
                
                toolbar.addItem({
                    name: "inviteNonOrgUserButton",
                    createToolbarItem: function () {
                        var addUserButton = new Solovis.UI.Buttons.Button({
                            element: $("<div>").text("Invite Non-Organization User"),
                            size: "small",
                            click: function () {
                                self._showInviteUserInterface();
                            }
                        });

                        return addUserButton;
                    }
                });
            }
            // Setup data grid
            let dataGridContainer = $("<div>").appendTo(this.container);

            let store = new DevExpress.data.ArrayStore({
                key: 'id',
                data: this._userList
            });

            dataGridContainer.dxDataGrid({
                dataSource: {
                    store: store,
                    sort: 'fullName'
                },

                allowColumnResizing: true,
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                searchPanel: { visible: true },
                columnChooser: { enabled: true },
                filterRow: {
                    visible: true
                },
                export: {
                    enabled: true
                },

                width: "100%",

                columns: [
                    {
                        dataField: 'fullName',
                        dataType: 'string',
                        caption: 'Full Name',
                        allowSorting: true,
                        cellTemplate: function (container, options) {
                            let userData = options.data;
                            let nameDiv = $("<div>").text(userData.fullName).appendTo(container);
                            if (userData.isLoginDisabled) {
                                nameDiv.css("color", "#f00");

                                $("<span>").text(" - DISABLED").css("color", "#333").appendTo(nameDiv);
                            }
                        },
                        width: 200
                    },
                    {
                        dataField: 'primaryEmail',
                        dataType: 'string',
                        caption:  !self._restrictedAdminUIEnabled ?'Primary Email': "eVestment Username",  
                        allowSorting: true,
                        width: 200,
                    },
                    {
                        dataField: 'contactEmail',
                        dataType: 'string',
                        caption: 'Contact Email',
                        allowSorting: true,
                        width: 200,
                        visible: self._restrictedAdminUIEnabled
                    },
                    {
                        dataField: 'isLoginDisabled',
                        dataType: 'boolean',
                        caption: 'Disabled',
                        visible: true,
                        allowSorting: true,
                        width: 150
                    },
                    {
                        dataField: 'requireMfa',
                        dataType: 'boolean',
                        caption: 'Require MFA',
                        visible: false,
                        allowSorting: true,
                        width: 150
                    },
                    {
                        dataField: 'code',
                        dataType: 'string',
                        caption: 'User Code',
                        visible: false,
                        allowSorting: true,
                        width: 150
                    },
                    {
                        caption: "Actions",
                        allowSorting: false,
                        cellTemplate: function (container, options) {
                            let userData = options.data;
                            self._buildActionsCell(container, userData);
                        },
                        width: 100
                    }
                ]
            });

            this._dataGrid = dataGridContainer.dxDataGrid("instance");
        }

        private _showAddOrgUserInterface() {
            var addUserDialog = new SolovisGateway.Admin.Organizations.OrgAddUserDialog({
                organizationId: this._organizationId,

                userAddedCallback: () => {
                    this._refreshUsersAsync();
                }
            });
            addUserDialog.show();
        }

        private _showInviteUserInterface() {
            var inviteDialog = new SolovisGateway.Admin.Organizations.OrgInviteUserDialog({
                organizationId: this._organizationId
            });
            inviteDialog.show();
        }

        private _showUnlockUserInterface(userData) {
            let self = this;

            Solovis.UI.confirm($("<div>").text("Unlock account for " + userData.primaryEmail + "."), "Unlock Account", function (confirmed) {
                if (confirmed) {
                    Solovis.Rpc.invokeAndWait(
                        "~/Organization/ClearTemporaryAccountLocks",
                        {
                            userId: userData.id
                        },
                        function (response, success) {
                            if (success) {
                                self._refreshUsersAsync();
                            }
                        });
                }
            });
        }

        private _buildActionsCell(container, userData) {
            let self = this;
            let columnDiv = container;

            if (!this._restrictedAdminUIEnabled) {
                let editUserLink = $("<a>").appendTo(columnDiv);
                $("<span class='fa fa-pencil'>").appendTo(editUserLink);
                editUserLink.attr("title", "Edit User");
                editUserLink.attr(
                    "href",
                    Solovis.resolveUrl("~/Organization/EditUser?userId=" + userData.id));

                let changePasswordLink = $("<a>").text("Change Password").appendTo(columnDiv);
                changePasswordLink.css("margin-left", "10px");
                changePasswordLink.attr("title", "Change Password");
                changePasswordLink.attr(
                    "href",
                    Solovis.resolveUrl("~/Organization/ChangePassword?userId=" + userData.id));
            }
            if (userData.isAccountLocked) {
                let unlockLink = $("<a>").text("Unlock").appendTo(columnDiv);
                unlockLink.css("margin-left", "10px");
                unlockLink.attr("title", "Unlock");
                unlockLink.click(() => this._showUnlockUserInterface(userData));
            }
        }


        private async _refreshUsersAsync(): Promise<void> {
            let self = this;

            let response = await Solovis.Rpc.invoke("~/Organization/GetOrganizationUsers", { organizationId: this._organizationId });

            this._userList = response.result.users.map(user => new OrganizationUser(user));

            let store = new DevExpress.data.ArrayStore({ key: 'id', data: this._userList });
            this._dataGrid.option("dataSource", store);
        }
    }
}